import { Link } from 'react-router-dom';

interface FooterProps {
  variant?: 'light' | 'dark' | 'auth';
}

export function Footer({ variant = 'dark' }: FooterProps) {
  const getTextColorClasses = () => {
    switch (variant) {
      case 'light':
        return 'text-white/80 hover:text-white';
      case 'auth':
        return 'text-[#361E06] hover:text-[#4A2B0B]';
      default:
        return 'text-gray-600 hover:text-gray-900';
    }
  };

  return (
    <footer className="">
      <div className="w-full px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div className={`text-sm ${variant === 'light' ? 'text-white/80' : variant === 'auth' ? 'text-[#361E06]' : 'text-gray-600'}`}>
            © {new Date().getFullYear()} Theos. All rights reserved.
          </div>
          <div className="flex space-x-6">
            <Link 
              to="/terms" 
              className={`text-sm ${getTextColorClasses()}`}
            >
              Terms of Service
            </Link>
            <Link 
              to="/privacy" 
              className={`text-sm ${getTextColorClasses()}`}
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
} 